import React, { Key, useEffect, useState } from "react";
import {
  Box, Button, Grid, IconButton, MenuItem, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Select, Dialog, DialogContent, DialogActions, DialogTitle,CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import Joi from "joi";
import { API } from 'aws-amplify';
import { getAPIName } from '../../config';
import DropdownWithSearch from '../helpercomponent/StaticDropDownSelectorWithSearch'
import ServerPaginationGrid from '../../components/vehicle-search.component';
import { navigate } from "@reach/router";
import useDebounce from '../helpers/useDebounce';
import { zonedTimeToUtc } from 'date-fns-tz';
import {
    faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AddAuthorityModal } from "../Forms/AddAuthorityModal";

const useStyles = makeStyles((theme) => ({
  spacedButton: { margin: theme.spacing(0, 1) },
  tableContainer: { 
    maxHeight: "70vh", 
    overflow: "auto", 
    borderRadius: 16,
    border: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
  },
  headerCell: { 
    fontWeight: 700, 
    fontSize: "0.85rem",         
    textAlign: "center",  
    backgroundColor: theme.palette.grey[50], 
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
    padding: "16px 8px"
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.02)"
    },
    transition: "background-color 0.2s ease"
  },
  tableCell: {
    padding: "12px 8px",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    verticalAlign: "middle",
    paddingLeft:"15px"
  },
  compactInput: { 
    "& .MuiInputBase-input": { 
      fontSize: "0.9rem", 
      padding: "8px 4px",
      textAlign: "center"
    },
    "& .MuiInputBase-root": {
      minHeight: "40px",
      display: "flex",
      alignItems: "center"
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`
    }
  },
  textareaInput: {
    "& .MuiInputBase-input": { 
      fontSize: "0.9rem", 
      textAlign: "left"
    },
    "& .MuiInputBase-root": {
      minHeight: "40px",
      display: "flex",
      alignItems: "flex-start"
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`
    }
  },
  authorityDropdown: {
    "& .MuiInputBase-root": {
      minHeight: "40px",
      display: "flex",
      alignItems: "center"
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`
    },
    "& .MuiAutocomplete-inputRoot": {
      minHeight: "40px"
    }
  },
  numericInput: {
    "& .MuiInputBase-input": { 
      fontSize: "0.9rem", 
      padding: "8px 4px",
      textAlign: "left",
      fontWeight: 600
    },
    "& .MuiInputBase-root": {
      minHeight: "40px",
      display: "flex",
      alignItems: "center"
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`
    }
  },
  errorInput: { 
    "& .MuiInput-underline:before": {
      borderBottom: `2px solid ${theme.palette.error.main}`
    },
    "& .MuiInput-underline:after": {
      borderBottom: `2px solid ${theme.palette.error.main}`
    }
  },
  modernButton: {
    borderRadius: 8,
    textTransform: "none",
    boxShadow: "none",
    padding: "6px 12px"
  },
  addBtnRow: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  rowPaper: { borderRadius: 16 },
  duplicateRow: {
    "& td": { 
      backgroundColor: "rgba(244,67,54,0.06)", 
      borderBottom: `1px solid ${theme.palette.error.light}` 
    },
    "& td:first-child": {
      position: "relative",
      "&::before": {
        content: '""',
        position: "absolute",
        left: 8,
        top: 8,
        bottom: 8,
        width: 4,
        borderRadius: 2,
        backgroundColor: theme.palette.error.main,
        pointerEvents: "none"
      }
    }
  },
  selectField: {
    "& .MuiSelect-root": {
      padding: "8px 4px",
      minHeight: "24px",
      display: "flex",
      alignItems: "center"
    },
    "& .MuiInputBase-root": {
      minHeight: "40px"
    }
  },
  vehicleButton: {
    borderRadius: 8,
    textTransform: "none",
    padding: "8px 12px",
    minHeight: "40px",
    fontSize: "0.85rem",
    border: `1px solid ${theme.palette.grey[300]}`,
    "&:hover": {
      backgroundColor: theme.palette.grey[50],
      border: `1px solid ${theme.palette.grey[400]}`
    }
  },
  vehicleButtonError: {
    borderRadius: 8,
    textTransform: "none",
    padding: "8px 12px",
    minHeight: "40px",
    fontSize: "0.85rem",
    border: `2px solid ${theme.palette.error.main}`,
    "&:hover": {
      backgroundColor: "rgba(244,67,54,0.04)",
      border: `2px solid ${theme.palette.error.main}`
    }
  },
  deleteButton: {
    transition: "all 0.2s ease"
  }
}));

export const getTollTypes = async(setter:any) =>{
  try {
    const response: any = await API.get(getAPIName(), "/tolltypes?allowed_charge=true", {});
    setter(response.body);
  } 
  catch (e) { 
    console.error(e); 
  }
}

type QuickToll = {
  id: string;
  type: number;
  dealershipId?: number;
  vehicleId?: number;
  description?: string;
  amount?: string;     
  adminfees?: string;
  transactiontimestamp: Date | null;
  searchTerm?: string;
  reference_number?: string;
  agency_id?: number;
  licenseplate?: string;
  agency_name?: string;
  agency_timezone?: string;
};

type RowState = QuickToll & {
  errors?: Partial<Record<keyof QuickToll, string>>;
  apiError?: string;
};

const createEmptyRow = (): RowState => ({
  id:  Date.now().toString(36) + Math.random().toString(36).substr(2),
  type: 1,
  dealershipId: undefined,
  vehicleId: undefined,
  description: undefined,
  amount: "",
  adminfees: "",
  transactiontimestamp: null,
  searchTerm: "",
  reference_number: "",
  agency_id: undefined,
  errors: {},
  apiError: undefined,
  agency_timezone: ''
});

const TollCreate = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [tollRows, setTollRows] = useState<RowState[]>([createEmptyRow()]);
  const [quickTollTypesList, setQuickTollTypesList] = useState<any[]>([]);
  const [openVehicleSearchModal, setOpenVehicleSearchModal] = useState(false);
  const [activeRowIdx, setActiveRowIdx] = useState<number | null>(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [tollsLoader, setTollsLoader] = useState(false);
  // Numeric input handler - only allows numbers and decimal point
  const handleNumericChange = (value: string): string => {
    const numericValue = value.replace(/[^0-9.]/g, '');
    const parts = numericValue.split('.');
    if (parts.length > 2) {
      return parts[0] + '.' + parts.slice(1).join('');
    }
    if (parts[1] && parts[1].length > 2) {
      return parts[0] + '.' + parts[1].substring(0, 2);
    }
    return numericValue;
  };

  const handleChange = (rowIndex: number, field: keyof QuickToll) => (value: any) => {
    setTollRows(prev => prev.map((row, idx) => {
      if (idx === rowIndex) {
        let processedValue = value;
        if ((field === 'amount' || field === 'adminfees') && typeof value === 'string') {
          processedValue = handleNumericChange(value);
        }
        const updatedRow = { 
          ...row, 
          [field]: processedValue, 
          errors: { ...row.errors, [field]: undefined } 
        };
        // Clear duplicate error if user modifies key fields that determine duplicates
        if (['vehicleId', 'amount', 'transactiontimestamp'].includes(field) && row.apiError === "Duplicate toll") {
          updatedRow.apiError = undefined;
        }
        return updatedRow;
      }
      return row;
    }));
  };

  const addRow = () => setTollRows(prev => [...prev, createEmptyRow()]);
  const removeRow = (rowIndex: number) => tollRows.length > 1 && setTollRows(prev => prev.filter((_, i) => i !== rowIndex));
  const handleOpenModal = (idx: number) => { setActiveRowIdx(idx); setOpenVehicleSearchModal(true); };
  const handleCloseModal = () => { setOpenVehicleSearchModal(false); setActiveRowIdx(null); };

  useEffect(() => {
    getTollTypes(setQuickTollTypesList);
  }, []);

  const apiTollSchema = Joi.object({
    type: Joi.number().required().messages({
      "any.required": "Select type"
    }),
    vehicleId: Joi.number().required().messages({
      "any.required": "Please select vehicle"
    }),
    description: Joi.string().required().messages({
      "any.required": "Add description"
    }),
    amount: Joi.number().max(350).required().messages({
      "number.max": "Amount cannot exceed $350",
      "any.required": "Add amount",
      "number.base": "Add amount"
    }),
    adminfees: Joi.number().max(350).required().messages({
      "number.max": "Admin fees cannot exceed $350",
      "any.required": "Add admin fees",
      "number.base": "Add admin fees"
    }),
    transactiontimestamp: Joi.date().required().messages({
    "any.required": "Select transaction date",
    "date.base": "Select transaction date",
    "date.empty": "Select transaction date"
    }),
    reference_number: Joi.string().allow("", null).messages({
      "string.base": "Enter citation number"
    }),
    agency_id: Joi.number().required().messages({
      "any.required": "Please select authority"
    }),
    agency_timezone: Joi.string().required().messages({
      "any.required": "Selected agency does not have timezone"
    })
  });

  const rowsForValidation = (rows: RowState[]) =>
    rows.map(r => ({ 
      ...r, 
      amount: r.amount ? parseFloat(r.amount) : undefined, 
      adminfees: r.adminfees ? parseFloat(r.adminfees) : undefined 
    }));

  const validateRows = (rows: RowState[]): RowState[] =>
    rows.map((row, i) => {
      const { error } = apiTollSchema.validate(rowsForValidation([row])[0], { abortEarly: false, allowUnknown: true });
      if (!error) return { ...row, errors: {} };
      const errors: RowState["errors"] = {};
      error.details.forEach(d => {
        const field = d.path[0] as keyof QuickToll;
        errors[field] = d.message;
      });
      return { ...row, errors };
    });

  // When user leaves amount/admin input: if there's a number without decimal, append .00 visually.
  const ensureTwoDecimals = (val?: string) => {
    if (!val || val === '') return "";
    const n = parseFloat(val);
    if (isNaN(n)) return val;
    return n.toFixed(2);
  };
  const handleSubmitBulkToll = async () => {
    setTollsLoader(true);
    const tollsForAPI = tollRows.map(toll => {
      const utc = toll.transactiontimestamp && new Date(toll.transactiontimestamp).toUTCString();
      const rawAmount = toll.amount ? parseFloat(toll.amount) : 0;
      const amount = toll.type === 133 ? -Math.abs(rawAmount) : rawAmount;
      let original_transactiontimestamp = toll.transactiontimestamp
      if (toll.agency_timezone && original_transactiontimestamp ) {
          original_transactiontimestamp = zonedTimeToUtc(
            original_transactiontimestamp,
            toll.agency_timezone
          );
        }
      let tranaction_time_formatted = original_transactiontimestamp && original_transactiontimestamp.toUTCString()
      return {
        amount,
        admin_fees: toll.adminfees ? parseFloat(toll.adminfees) : 0,
        dealershipid: toll.dealershipId,
        description_entry: toll.description,
        description_exit: toll.description,
        posted_time: tranaction_time_formatted,
        postingdate: null,
        toll_status_id: 9,
        toll_type_id: toll.type,
        vehicleid: toll.vehicleId,
        entry_time: null,
        exit_time: null,
        transaction_time: tranaction_time_formatted,
        reference_number: toll.reference_number ?? null,
        agency_id: toll.agency_id ?? null,
      };
    });
    try {
      const res = await API.post(getAPIName(), "/tolls?mode=bulk", { body: tollsForAPI });
      if (res.message === "All tolls processed successfully") {
        enqueueSnackbar("All tolls processed successfully", { variant: "success" });
        navigate('/tolls');
        return;
      }
    } catch (error) {
      const err = error as any;
      if (err.response?.data?.duplicateTollIndex !== undefined) {
        const dupIdx = err.response.data.duplicateTollIndex;
        setTollRows(prev => prev.map((row, i) =>
          i === dupIdx ? { ...row, apiError: "Duplicate toll" } : { ...row, apiError: undefined }
        ));
        enqueueSnackbar(`Row ${dupIdx + 1} is a duplicate toll`, { variant: "error" });
      } else {
        enqueueSnackbar("API error occurred", { variant: "error" });
        console.error(err);
      }
    }finally {
      setTollsLoader(false);
    }
  };

  const quickTollTypes = quickTollTypesList
    .filter(e => e.id !== 34 && e.id !== 166)
    .map(type => <MenuItem key={type.id} value={type.id}>{type.description}</MenuItem>);
  const activeSearchTerm = activeRowIdx !== null ? tollRows[activeRowIdx].searchTerm || "" : "";
  const debouncedSearchTerm = useDebounce(activeSearchTerm, 300);
  const handleConfirmationModal = () => {
    const validated = validateRows(tollRows);
    setTollRows(validated);
    const rowErrors = validated.map((row, i) => {
      const msgs = Object.entries(row.errors || {}).map(([f, msg]) => {
        // Special case: only show timezone error if agency_name exists
        if (f === "agency_timezone" && !row.agency_name) return null;
        return msg;
      }).filter(Boolean);

      return msgs.length ? `Row ${i + 1}: ${msgs.join(", ")}` : null;
    }).filter(Boolean) as string[];
      if (rowErrors.length > 0) {
        const first = rowErrors[0];
        const extra = rowErrors.length > 1 ? ` ...and ${rowErrors.length - 1} more errors` : "";
        enqueueSnackbar(`${first}${extra}`, { variant: "error" });
        return;
      }

      setOpenConfirm(true);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box className={classes.addBtnRow} mb={2}>
          <Typography variant="h5" style={{ fontWeight: 600, color: "#2c3e50" }}>Quick Charge</Typography>
          <Button
            variant="contained" color="primary" size="small"
            startIcon={<AddIcon />} onClick={addRow}
            className={`${classes.spacedButton} ${classes.modernButton}`}
          >Add Row</Button>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} className={classes.tableContainer} elevation={0} style={{ position: "relative" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell} style={{ minWidth: 140 }}>Transaction Date</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 120 }}>Vehicle</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 120 }}>Type</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 320 }}>Description</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 100 }}>Amount</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 100 }}>Admin Fees</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 150 }}>Citation Number</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 340 }}>Authority</TableCell>
                <TableCell className={classes.headerCell} style={{ minWidth: 40 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tollRows.map((row, idx) => (
                <TableRow key={row.id} className={`${classes.tableRow} ${row.apiError ? classes.duplicateRow : ""}`}>
                  <TableCell className={classes.tableCell}>
                      <TextField
                        type="datetime-local"
                        fullWidth
                        variant="standard"
                        value={row.transactiontimestamp || ""}
                        onChange={e => handleChange(idx, "transactiontimestamp")(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        className={`${classes.compactInput} ${row.errors?.transactiontimestamp ? classes.errorInput : ""}`}
                      />
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <Button 
                      variant="outlined" 
                      fullWidth 
                      onClick={() => handleOpenModal(idx)} 
                      className={row.errors?.vehicleId ? classes.vehicleButtonError : classes.vehicleButton}
                    >
                      {row.licenseplate || (<><FontAwesomeIcon icon={faSearch} /></>)}
                    </Button>
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <Select 
                      fullWidth 
                      value={row.type} 
                      onChange={e => handleChange(idx, "type")(e.target.value)} 
                      className={`${classes.selectField} ${row.errors?.type ? classes.errorInput : ""}`}
                      variant="standard"
                    >
                      {quickTollTypes}
                    </Select>
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                      <TextField
                        fullWidth
                        variant="standard"
                        placeholder="Description"
                        value={row.description}
                        onChange={e => handleChange(idx, "description")(e.target.value)}
                        multiline
                        maxRows={4}
                        className={`${classes.textareaInput} ${row.errors?.description ? classes.errorInput : ""}`}
                      />
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <TextField
                      fullWidth
                      variant="standard"
                      value={row.amount ?? ""}
                      onChange={e => handleChange(idx, "amount")(e.target.value)}
                      onBlur={e => handleChange(idx, "amount")(ensureTwoDecimals(e.target.value))}
                      className={`${classes.numericInput} ${row.errors?.amount ? classes.errorInput : ""}`}
                      InputProps={{ 
                        startAdornment: <span style={{ marginRight: 4, fontSize: "0.9rem", fontWeight: 600 }}>$</span>
                      }}
                      inputProps={{
                        inputMode: 'decimal',
                        pattern: '[0-9]*[.]?[0-9]*'
                      }}
                    />
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <TextField
                      fullWidth
                      variant="standard"
                      value={row.adminfees ?? ""}
                      onChange={e => handleChange(idx, "adminfees")(e.target.value)}
                      onBlur={e => handleChange(idx, "adminfees")(ensureTwoDecimals(e.target.value))}
                      className={`${classes.numericInput} ${row.errors?.adminfees ? classes.errorInput : ""}`}
                      InputProps={{ 
                        startAdornment: <span style={{ marginRight: 4, fontSize: "0.9rem", fontWeight: 600 }}>$</span>
                      }}
                      inputProps={{
                        inputMode: 'decimal',
                        pattern: '[0-9]*[.]?[0-9]*'
                      }}
                    />
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <TextField 
                      fullWidth 
                      variant="standard"
                      value={row.reference_number} 
                      onChange={e => handleChange(idx, "reference_number")(e.target.value)} 
                      className={`${classes.compactInput} ${row.errors?.reference_number ? classes.errorInput : ""}`} 
                    />
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <div className={`${classes.authorityDropdown} ${row.errors?.agency_id ? classes.errorInput : ""}`}>
                      <DropdownWithSearch
                        options_path="/tollagencies"
                        addOption={{
                          label: '+ Add Authority',
                        }}
                        addModal={({ open, onClose, onSuccess }) => (
                          <AddAuthorityModal
                            open={open}
                            onClose={onClose}
                            onSuccess={onSuccess}
                          />
                        )}
                        editModal={({ open, onClose, onSuccess, option }) => (
                          <AddAuthorityModal
                            open={open}
                            onClose={onClose}
                            onSuccess={onSuccess}
                            authority={option.data}
                          />
                        )}
                        key_selector="id"
                        value_selector="name"
                        additional_selector_value="description" 
                        onChange={(value: any) => {handleChange(idx, "agency_id")(value?.value);handleChange(idx, "agency_name")(value?.label);handleChange(idx, "agency_timezone")(value?.data?.agency_timezone)}}
                        label="select"
                      />
                    </div>
                  </TableCell>

                  <TableCell className={classes.tableCell}>
                    <IconButton size="small" onClick={() => removeRow(idx)} disabled={tollRows.length === 1} color="secondary">
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* Loader */}
          {tollsLoader && (
            <Box
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(6px)",
                backgroundColor: "rgba(240,240,240,0.37)",
                zIndex: 10,
                borderRadius: 16
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </TableContainer>
      </Grid>
      <Grid item xs={12} container justifyContent="center" spacing={2} style={{ paddingTop: "3rem" }}>
        <Button size="small" variant="outlined" color="primary" className={classes.spacedButton} onClick={()=>setTollRows([createEmptyRow()])}>Reset</Button>
        <Button size="small" variant="contained" color="primary" onClick={() => handleConfirmationModal()}>
          Save All ({tollRows.length} rows)
        </Button>
      </Grid>
      {/* Vehicle Search Modal */}
      <Dialog
          open={openVehicleSearchModal}
          onClose={handleCloseModal}
          fullWidth
          maxWidth="md"
          PaperProps={{ style: { margin: 0, top: 160, position: "absolute" } }}
        >
          <DialogContent>
            {activeRowIdx !== null && (
              <>
                <TextField
                  fullWidth
                  placeholder="License Plate / VIN"
                  value={activeSearchTerm}
                  onChange={e =>
                    handleChange(activeRowIdx, "searchTerm")(e.target.value)
                  }
                />
                {debouncedSearchTerm && (
                  <ServerPaginationGrid
                    searchTerm={debouncedSearchTerm}
                    handleChange={(vehicleInfo: any) => {
                      handleChange(activeRowIdx, "vehicleId")(vehicleInfo.vehicleId);
                      handleChange(activeRowIdx, "licenseplate")(vehicleInfo.licenseplate);
                      handleChange(activeRowIdx, "dealershipId")(vehicleInfo.dealershipId);
                      handleCloseModal();
                    }}
                    vehicleWithNonActiveContract={false}
                  />
                )}
              </>
            )}
          </DialogContent>
      </Dialog>
      {/* Confirmation Modal */}
        <Dialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          fullWidth
          maxWidth="md"
          PaperProps={{ style: { borderRadius: 16, padding: "8px 16px" } }}
        >
          <DialogTitle
            style={{ textAlign: "center", fontWeight: 700, fontSize: "1.2rem" }}
          >
            Can you confirm the changes?
          </DialogTitle>
          <DialogContent style={{ padding: "0 8px 16px" }}>
            <TableContainer component={Paper} elevation={2} style={{ borderRadius: 12 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow style={{ background: "#f5f7fa" }}>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Transaction Time
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                     Type
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Vehicle
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Amount
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Admin Fees
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Description
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: 600 }}>
                      Authority
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tollRows.map((r, i) => (
                    <TableRow
                      key={r.id}
                      style={{ backgroundColor: i % 2 === 0 ? "#fff" : "#fafafa" }}
                    >
                      <TableCell align="center">
                        {r.transactiontimestamp
                          ? new Date(r.transactiontimestamp).toLocaleString("en-US",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit",hour12:true}).toLowerCase()
                          : "-"}
                      </TableCell>
                      <TableCell align="center">{r.type || "-"}</TableCell>
                      <TableCell align="center">{r.licenseplate || "-"}</TableCell>
                      <TableCell align="center" style={{ fontWeight: 600 }}>
                        {r.amount ? `$${r.amount}` : "-"}
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: 600 }}>
                        {r.adminfees ? `$${r.adminfees}` : "-"}
                      </TableCell>
                      <TableCell align="center">{r.description || "-"}</TableCell>
                      <TableCell align="center">{r.agency_name || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>

          <DialogActions style={{ justifyContent: "center", paddingBottom: 16 }}>
            <Button
              onClick={() => setOpenConfirm(false)}
              color="secondary"
              variant="outlined"
              style={{ borderRadius: 8, textTransform: "none" }}
            >
              Back
            </Button>
            <Button
              onClick={() => {
                setOpenConfirm(false);
                handleSubmitBulkToll();
              }}
              color="primary"
              variant="contained"
              style={{ borderRadius: 8, textTransform: "none" }}
            >
              Yes, Save
            </Button>
          </DialogActions>
        </Dialog>
    </Grid>
  );
};

export default TollCreate;